import PropTypes from 'prop-types';


import {emailConstants} from '../Email';
import {phoneConstants} from './Phone';


// ------ shapes
export const SHAPE_IS_NEWSLETTER_RECIPIENT = PropTypes.bool.isRequired;

export const SHAPE_IS_REACHABLE_VIA_PHONE = PropTypes.bool.isRequired;

export const SHAPE_NAME = PropTypes.string;

export const SHAPE_POSITION = PropTypes.string;

export const SHAPE_SURNAME = PropTypes.string;


export const SHAPE_CONTACT = PropTypes.shape({
    email: emailConstants.SHAPE_EMAIL,
    isNewsletterRecipient: SHAPE_IS_NEWSLETTER_RECIPIENT,
    isReachableViaPhone: SHAPE_IS_REACHABLE_VIA_PHONE,
    name: SHAPE_NAME,
    phone: phoneConstants.SHAPE_PHONE,
    position: SHAPE_POSITION,
    surname: SHAPE_SURNAME
});
